import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {

  getConfigItems({ dispatch, commit }) {
    axios
      .get("customer/config")
      .then((res) => {
        commit("setConfigItems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPageContent({ dispatch, commit }, data) {
    axios
      .get("customer/page/" + data)
      .then((res) => {
        commit("setPageContent", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBanners({ dispatch, commit }) {
    axios
      .get("customer/banner")
      .then((res) => {
        commit("setBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

// Users Actions ------------------------------------------------------------------
  getBankCards({ dispatch, commit }) {
    axios
      .get("customer/card")
      .then((res) => {
        commit("setBankCards", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankCard({ dispatch, commit }, data) {
    axios
      .get("customer/card/" + data)
      .then((res) => {
        commit("setBankCard", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBankCard({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("customer/card", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBankCard({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("customer/card/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBankCard({ dispatch }, data) {
    axios
      .delete("customer/card/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

// Ticket Actions ------------------------------------------------------------------
  getTickets({ dispatch, commit }) {
    axios
      .get("customer/ticket")
      .then((res) => {
        commit("setTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTicket({ dispatch, commit }, data) {
    axios
      .get("customer/ticket/" + data)
      .then((res) => {
        commit("setTicket", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTicket({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("customer/ticket", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTicket({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("customer/ticket/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTicket({ dispatch }, data) {
    axios
      .delete("customer/ticket/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },


// others API Actions --------------------------------------------------------------
  addSuggestedShop({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("customer/suggestShop", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: 'Profile',
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

// Dashboard Actions ------------------------------------------------------------------
  getDashboardItems({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("customer/dashboard")
      .then((res) => {
        commit("setDashboardItems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  searchVendors({ dispatch, commit }, data) {
    axios
      .get("customer/dashboard/search?key=" + data)
      .then((res) => {
        commit("setSearchVendors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequirementProfile({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("customer/Profile/RequirementProfile")
      .then((res) => {
        commit("setRequirementProfile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },


};
